import gql from "graphql-tag";

export const GetPrices = gql`
  query GetPrices($competitions: AWSJSON!, $coupons: String) {
    getPrices(competitions: $competitions, coupons: $coupons) {
      competitionId
      orig_price
      discount
      sale_price
      tax
      total
    }
  }
`;

// TODO see ei peaks siin olema
export const CreateMyPayment = gql`
  mutation CreateMyPayment($input: CreateMyPaymentInput!) {
    createMyPayment(input: $input) {
	teamIds
        data
        total
        subtotal
        tax
        success
    }
  }
`;


export const CreateMyPurcaseOrder = gql`
  mutation CreateMyPurcaseOrder($input: CreateMyPurchaseOrderInput!) {
    createMyPurchaseOrder(input: $input) {
      given_name
      family_name
      company_name
      company_code
      address_1
      address_2
      city
      state
      zip
      country
      email
      phone
      coupons
      teams
      teamIds
    }
  }
`;




// WEBPACK FOOTER //
// ./src/private/user/containers/Payment/graphql.js